import { FC, memo } from 'react';
import Link from 'next/link'
import NextImage from 'next/image';
import Box from '@material-ui/core/Box';
import ArrowLeft from '@keaze/web/public/svg/ArrowLeft.svg'
import styled from 'styled-components';
import { Status } from '@keaze/web/components/status';
import {
  Address,
  Header as UIHeader,
  Schemes,
  MobileSchemes,
  StyledSchema,
  Statuses,
  SchemesWrapper,
  MobileMapButton,
  TitleWrapper,
  Title,
  StyledActions,
  ArrowLeftBlock,
} from './header.styles';
import { Scheme } from '@keaze/web/common/interfaces';
import { HeaderProps } from './header.types';

type RenderScheme = (scheme: Scheme) => JSX.Element;


const S = {


BackToSearch: styled.div`
${({ theme: { breakpoints, colors, palette} }) => `
        color: ${colors.greens.green0};
        padding-top: 25px;
        font-size: 12px;
        margin-bottom: 10px;
        cursor: pointer;
        &::before {
          margin-right: 5px;
          content: url(/svg/ArrowLeft.svg);
          mask: url(/svg/ArrowLeft.svg) no-repeat center
         }

   } 

    ${breakpoints.up('md')} {
        padding-top: 0;
    }
`}
`
}


const renderScheme: RenderScheme = ({ text, color }) => (
  <StyledSchema key={text} withoutTail backgroundColor={color}>
    {text}
  </StyledSchema>
);

export const Header: FC<HeaderProps> = memo(
  ({
    name,
    address,
    newBuild,
    schemes,
    availabilityStatus,
    listingId,
    listingSlug,
    favourite,
    isListingLoading,
    onMapClick,
  }) => (
    <UIHeader container>

      <Box>
      
      <Link href={'/search'}>
        <S.BackToSearch>
        Back to 
        <strong> Search Results</strong>
        </S.BackToSearch>
        </Link>
  

        <TitleWrapper container alignItems="center">
          <Title variant="h1">{name}</Title>
          {/* <Schemes>{schemes.map(renderScheme)}</Schemes> */}
        </TitleWrapper>
        <Box>
          <Address variant="body2">{address}</Address>
          {/* commenting out a designs do not specify it
          <Statuses>
            <Status variant="caption" name={availabilityStatus.name} />
            {newBuild && <Status variant="caption" />}
          </Statuses> */}
        </Box>
     
      </Box>
      <SchemesWrapper>
        <StyledActions
          listingId={listingId}
          listingSlug={listingSlug}
          listingSchemes={schemes}
          favourite={favourite}
          isLoading={isListingLoading}
        />
        <MobileSchemes>{schemes.map(renderScheme)} </MobileSchemes>
        {/* <MobileMapButton
          size="small"
          startIcon={
            <NextImage
              src="/svg/map.svg"
              alt="map icon"
              width={21}
              height={20}
              priority
            />
          }
          onClick={() => onMapClick('open')}
        >
          Map
        </MobileMapButton> */}

      </SchemesWrapper>
    </UIHeader>
  )
);
